/**
 * Image Gallery Product Card Interactive Features
 * Handles image hover effects and variant swatches
 */
class ImageGalleryCard {
  constructor(element) {
    this.card = element;
    this.imageWrapper = this.card.querySelector('.gallery-card__image-wrapper');
    this.mainMedia = this.card.querySelector('.gallery-card__media--main');
    this.mainImage = this.card.querySelector('img.gallery-card__media--main');
    this.hoverMedia = null;
    this.swatches = this.card.querySelectorAll('.gallery-card__swatch');

    this.init();
  }

  init() {
    this.updateHoverMediaReference();

    // Image hover effect
    if (this.imageWrapper) {
      this.imageWrapper.addEventListener('mouseenter', () => this.handleImageHover(true));
      this.imageWrapper.addEventListener('mouseleave', () => this.handleImageHover(false));
    }

    // Variant swatch interaction
    this.swatches.forEach(swatch => {
      swatch.addEventListener('click', (e) => this.handleSwatchClick(e));
      swatch.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.handleSwatchClick(e);
        }
      });
    });
  }

  updateHoverMediaReference() {
    this.hoverMedia = this.card.querySelector('.gallery-card__media--hover');
  }

  getHoverVideo() {
    if (!this.hoverMedia) return null;
    if (this.hoverMedia.tagName === 'VIDEO') return this.hoverMedia;
    return this.hoverMedia.querySelector('video');
  }

  handleImageHover(isHovering) {
    if (!this.mainMedia) return;

    if (isHovering && this.hoverMedia) {
      this.mainMedia.style.opacity = '0';
      this.hoverMedia.style.opacity = '1';
      this.hoverMedia.style.transform = 'translate(-50%, -50%) scale(1.04)';

      if (this.mainMedia.tagName === 'VIDEO') {
        this.mainMedia.pause();
      }

      const video = this.getHoverVideo();
      if (video) {
        video.play().catch(e => console.log('Video autoplay prevented:', e));
      }
    } else {
      this.mainMedia.style.opacity = '1';
      if (this.hoverMedia) {
        this.hoverMedia.style.opacity = '0';
        this.hoverMedia.style.transform = 'translate(-50%, -50%) scale(1)';

        const video = this.getHoverVideo();
        if (video) {
          video.pause();
          video.currentTime = 0;
        }
      }

      if (this.mainMedia.tagName === 'VIDEO') {
        this.mainMedia.play().catch(() => {});
      }
    }
  }

  handleSwatchClick(event) {
    const swatch = event.currentTarget;
    const variantImage = swatch.dataset.variantImage;

    this.swatches.forEach(s => s.classList.remove('active'));
    swatch.classList.add('active');

    if (variantImage && variantImage !== '' && this.mainImage) {
      this.mainImage.src = variantImage;
      const width400 = variantImage.replace(/width=\d+/, 'width=400');
      const width600 = variantImage.replace(/width=\d+/, 'width=600');
      const width800 = variantImage.replace(/width=\d+/, 'width=800');
      this.mainImage.srcset = `${width400} 400w, ${width600} 600w, ${width800} 800w`;
    }
  }
}

function initImageGalleryCards() {
  const cards = document.querySelectorAll('.gallery-card');
  cards.forEach(card => new ImageGalleryCard(card));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initImageGalleryCards);
} else {
  initImageGalleryCards();
}

window.ImageGalleryCard = ImageGalleryCard;
window.initImageGalleryCards = initImageGalleryCards;
